import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    const errorMessage =
      error?.message ||
      error?.originalError?.message ||
      (typeof error === 'string' ? error : '') ||
      '';

    const isChunkError =
      error?.name === 'ChunkLoadError' ||
      /Loading chunk [\d\w-]+ failed/i.test(errorMessage) ||
      /failed to fetch dynamically imported module/i.test(errorMessage) ||
      /error loading dynamically imported module/i.test(errorMessage) ||
      /Loading CSS chunk/i.test(errorMessage);

    if (isChunkError) {
      console.warn('[GlobalErrorHandler] Detectado fallo de carga de chunk (versión desactualizada):', errorMessage);

      const reloadKey = 'chunk_reload_attempted_at';
      const lastAttempt = sessionStorage.getItem(reloadKey);
      const now = Date.now();

      // Si no se ha intentado una recarga en los últimos 20 segundos, recargamos automáticamente
      if (!lastAttempt || now - parseInt(lastAttempt, 10) > 20000) {
        sessionStorage.setItem(reloadKey, now.toString());
        console.log('[GlobalErrorHandler] Recargando automáticamente para sincronizar con la nueva versión desplegada...');
        window.location.reload();
        return;
      } else {
        console.error('[GlobalErrorHandler] Reintento de recarga por chunk fallido ya ejecutado recientemente. Evitando bucle infinito.');
      }
    }

    // Comportamiento por defecto de Angular: log en consola
    console.error(error);
  }
}
